/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

function Toggle({ onClick, value }) {
  return (
    <div
      className={`Toggle--${value ? 'right' : 'left'}`}
      onClick={() => {
        onClick(!value);
      }}
      role="button"
    />
  );
}

Toggle.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
};

export default Toggle;
